<template lang="pug">
  ModalLayout(
    type="banner"
    :active="active"
    @hide="hide"
  )
    .banner__wrapper
      .banner__image
        img(src="~@/assets/img/header/banner/marmelade/banner-product.png")
        img.shadow(src="~@/assets/img/header/banner/marmelade/banner-product-shadow.png")
    .banner__wrapper.banner__wrapper--content
      .banner__content
        h1.banner__content-title {{ $t('header.banner.popup.title.text_1') }}
          div
            span {{ $t('header.banner.popup.title.accent') }}
            | {{ $t('header.banner.popup.title.text_2') }}
          | {{ $t('header.banner.popup.title.text_3') }}
        ul.banner__content-list
          li
            img(src="~@/assets/img/header/banner/marmelade/banner-list-1.svg")
            div
              | {{ $t('header.banner.popup.list.item_1_1') }}
              div {{ $t('header.banner.popup.list.item_1_2') }}
          li
            img(src="~@/assets/img/header/banner/marmelade/banner-list-2.svg")
            div
              | {{ $t('header.banner.popup.list.item_2_1') }}
              div {{ $t('header.banner.popup.list.item_2_2') }}
          li
            img(src="~@/assets/img/header/banner/marmelade/banner-list-3.svg")
            div
              | {{ $t('header.banner.popup.list.item_3_1') }}
              div {{ $t('header.banner.popup.list.item_3_2') }}
          li
            img(src="~@/assets/img/header/banner/marmelade/banner-list-4.svg")
            div
              | {{ $t('header.banner.popup.list.item_4_1') }}
              div {{ $t('header.banner.popup.list.item_4_2') }}
        <MarketplaceGummies />
</template>

<script>
import modals from '@/mixins/modals'
import MarketplaceGummies from '@/components/marketplaceGummies/MarketplaceGummies.vue'

export default {
  name: 'ModalBanner',
  components: { MarketplaceGummies },
  mixins: [modals]
}
</script>
